import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global/global.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-modal-wellcome',
  templateUrl: './modal-wellcome.component.html',
  styleUrls: ['./modal-wellcome.component.scss'],
})
export class ModalWellcomeComponent implements OnInit {
  constructor(
    public globalService: GlobalService,
    public dialogRef: MatDialogRef<ModalWellcomeComponent>,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.dialogRef.afterClosed().subscribe(() => {
      this.storageService.deleteUserProcess().subscribe();
    });
  }

  close() {
    this.dialogRef.close();
  }
}
